import { render, staticRenderFns } from "./BotManageBehavior.vue?vue&type=template&id=231562f3&"
import script from "./BotManageBehavior.vue?vue&type=script&lang=js&"
export * from "./BotManageBehavior.vue?vue&type=script&lang=js&"
import style0 from "./BotManageBehavior.vue?vue&type=style&index=0&id=231562f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports